import { authStore } from "./AuthStore.js";
import { LoginBase } from "./login-base.js";
import { LoginComponent } from "./login-component.js";

export class PasswordRecoveryForm extends LoginBase {
    static webComponentName: string = 'password-recovery-form';
    protected _templateId: string = 'password-recovery-form';
    private _isLoading: boolean = false;
    public get isLoading(): boolean {
        return this._isLoading;
    }
    public get email(): string {
        return this.parentComponent.email;
    }
    public set email(value: string) {
        this.parentComponent.email = value;
    }
    private get emailEl(): HTMLInputElement | null {
        return this.querySelector('input[name="email"]');
    }
    public set isLoading(value: boolean) {
        const changed = (this._isLoading != value);
        this._isLoading = value;
        this.handleLoading();
    }
    private _resetError: string = '';
    public get resetError(): string {
        return this._resetError;
    }
    public set resetError(value: string) {
        this._resetError = value;
    }
    private _resetSuccess: boolean = false;
    public get resetSuccess(): boolean {
        return this._resetSuccess;
    }
    public set resetSuccess(value: boolean) {
        this._resetSuccess = value;
    }
    protected onConnected(): void {
        this.setupListeners();
        super.onConnected();
    }
    private get parentComponent(): LoginComponent | null {
        return this.closest('login-component');
    }
    private get btnLoginSubmit(): HTMLButtonElement | null {
        return this.roleElementSelector("handle-submit-reset") as HTMLButtonElement | null;
    }
    setupListeners() {
        // Configura gli event listener specifici per il modulo di recupero password
       
        this.on('click', `[role="handle-toggle-recovery"]`, (e: Event) => {
            e.preventDefault();
            this.handleToggleRecovery();
        });
        this.on('input', 'input[name="email"]', (e: Event) => {
            e.preventDefault();
            const target = e.target as HTMLInputElement;
            this.email = target.value;
            this.handleBtnSubmitState();
        });
        this.on('click', `[role="resend-reset-email"]`, (e: Event) => {
            e.preventDefault();
            this.resendResetEmail(e);
        });
        this.on('click', `[role="clear-reset-error"]`, (e: Event) => {
            e.preventDefault();
            this.resetError = "";
            this.resetSuccess = false;
            this.isLoading = false;
            this.render();
        });
        this.on('submit', `form[role="handle-password-reset"]`, async (e: Event) => {
            e.preventDefault();
            await this.handlePasswordReset(e);
        });
    }
    handleLoading() {
        this.emailEl?.toggleAttribute("disabled", this.isLoading);
        this.handleBtnSubmitState();
        Array.from(this.querySelectorAll('.loading')).forEach(el => el.classList.toggle('d-none', !this.isLoading));
        Array.from(this.querySelectorAll('.not-loading')).forEach(el => el.classList.toggle('d-none', this.isLoading));
    }
    handleBtnSubmitState() {
        this.btnLoginSubmit?.toggleAttribute("disabled", this.isLoading || !this.email ||  !this.emailEl?.checkValidity());
    }
    handleToggleRecovery() {
        const parent = this.parentComponent;
        if (parent) {
            parent.isPasswordRecovery = false;
        }
    }
    resendResetEmail(event: Event) {
        this.resetError = "";
        this.resetSuccess = false;
        this.isLoading = false;
        this.render();
    }
    async handlePasswordReset(event: Event) {
        event.preventDefault();

        // Reset stati
        this.resetError = "";
        this.resetSuccess = false;
        this.isLoading = true;
        if (!this.emailEl.checkValidity()) {
            this.emailEl.classList.add("is-invalid");
            return;
        }
        try {
            const resetResult = await authStore.requestPasswordReset(this.email);
            if (resetResult.success) {
                this.resetSuccess = true;
                // Non mostrare il messaggio del server per sicurezza, usa un messaggio generico
            } else {
                this.resetError = resetResult.error || 'Errore durante la richiesta di reset password';
            }
        } catch (error) {
            console.error("Password reset error:", error);
            this.resetError = 'Errore durante la richiesta di reset password. Riprova.';
        } finally {
            this.isLoading = false;
            this.render();
        }
    };
    protected buildRenderingData(): Record<string, any> {
        const data = super.buildRenderingData();
        return {
            ...data,
            email: this.email,
            resetError: this.resetError,
            resetSuccess: this.resetSuccess,
            isLoading: this.isLoading,
        }
    }
    protected afterRender(): void {
        super.afterRender();
        this.handleBtnSubmitState();
    }
}